export default {
  LOADING: 'loading',
  USER: 'user',
  I18N: 'i18n',
};
